export default __webpack_public_path__ + "assets/images/16d72908d5ecb9b0aab15353bb4b5797.png";